export default {
  metadata: {
    version: '1.0.0',
    id: 'mobile-bottom-sheet-1.0.0',
    name: 'JDSMobileBottomSheet'
  },
  hierarchy: {
    popup: [
      {
        'popup-container': ['jds_mobile_bottom_sheet_internal']
      }
    ]
  },
  base: {
    popup: {
      priority: 60,
      passive: true
    },
    'popup-container': {
      show: true,
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.end}',
      size: '{size.max}',
      'enter-animation-name': 'fadeIn',
      'exit-animation-name': 'fadeOut',
      'enter-animation-curve': 'entrance_ease',
      'exit-animation-curve': 'exit_ease',
      'enter-animation-duration': 500,
      'exit-animation-duration': 500,
      'background-color': '{custom_color_3}',
      opacity: '{opacity.invisible}',
      transition: {
        property: ['opacity'],
        duration: '{medium}',
        'timing-function': '{easeEntrance}'
      }
    },
    jds_mobile_bottom_sheet_internal: {
      hidden: false
    }
  },
  variant: {
    kind: {
      passive: {
        popup: {
          passive: true,
          'background-color': 'transparent'
        },
        'popup-container': {
          'background-color': 'transparent'
        },
        jds_mobile_bottom_sheet_internal: {
          kind: 'passive'
        }
      }
    },
    isCustom: {
      true: {
        jds_mobile_bottom_sheet_internal: {
          isCustom: true
        }
      }
    },
    close: {
      false: {
        'popup-container': {
          opacity: '{opacity.enabled}',
          transition: {
            'timing-function': '{easeExit}'
          }
        },
        jds_mobile_bottom_sheet_internal: {
          close: false
        }
      }
    },
    controlType: {
      stepper: {
        jds_mobile_bottom_sheet_internal: {
          controlType: 'stepper'
        }
      }
    },
    primaryCtaDisabled: {
      true: {
        jds_mobile_bottom_sheet_internal: {
          primaryCtaDisabled: true
        }
      }
    },
    secondaryCtaDisabled: {
      true: {
        jds_mobile_bottom_sheet_internal: {
          secondaryCtaDisabled: true
        }
      }
    }
  },
  combination: [
    {
      false: {
        overlay: {
          popup: {
            passive: false
          }
        }
      }
    }
  ],
  combination_config: [['close', 'kind']],
  api: {
    config: {
      kind: {
        values: ['overlay', 'passive']
      },
      controlType: {
        values: ['normal', 'stepper']
      },
      isCustom: {
        values: [false, true]
      },
      close: {
        values: [true, false]
      },
      primaryCtaDisabled: {
        values: [false, true]
      },
      secondaryCtaDisabled: {
        values: [false, true]
      }
    },
    data: {
      jds_mobile_bottom_sheet_internal: {
        maxHeight: {
          type: 'size',
          name: 'height',
          function: true
        },
        stepLabel: {
          type: 'string',
          name: 'label'
        },
        title: {
          type: 'string',
          name: 'title'
        },
        description: {
          type: 'string',
          name: 'description'
        },
        primaryCTA: {
          type: 'string',
          name: 'primaryCTA'
        },
        secondaryCTA: {
          type: 'string',
          name: 'secondaryCTA'
        },
        children: {
          name: 'children',
          type: 'slot'
        }
      }
    },
    events: {
      popup: {
        onClick: 'onClose'
      },
      jds_mobile_bottom_sheet_internal: {
        onBottomSheetClick: '_onBottomSheetClick',
        onClose: 'onClose',
        onBack: 'onBack',
        onCancel: 'onCancel',
        onPrimaryClick: 'onPrimaryClick',
        onSecondaryClick: 'onSecondaryClick'
      }
    },
    a11y: {
      jds_mobile_bottom_sheet_internal: {
        properties: {
          ariaLabel: 'ariaLabel',
          ariaDescribedby: {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          },
          cancelButtonAriaLabel: 'cancelButtonAriaLabel',
          backButtonAriaLabel: 'backButtonAriaLabel',
          primaryCtaAriaLabel: 'primaryCtaAriaLabel',
          primaryCtaAriaDescribedby: {
            name: 'primaryCtaAriaDescribedby',
            platform: 'web,ios'
          },
          secondaryCtaAriaLabel: 'secondaryCtaAriaLabel',
          secondaryCtaAriaDescribedby: {
            name: 'secondaryCtaAriaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
